// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__39x3E","closeButton":"Modal_closeButton__2nWtu","root":"Modal_root__2dZKB"};